import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Output,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from '@progress/kendo-angular-buttons';
import { AvatarModule } from '@progress/kendo-angular-layout';
import { NotificationSettings } from '@progress/kendo-angular-notification';
import {
  ProgressBarAnimation,
  ProgressBarModule,
} from '@progress/kendo-angular-progressbar';
import { AnimationEndEvent } from '@progress/kendo-angular-progressbar';

import {
  AvatarColorDirective,
  AvatarColor,
} from '../../directives/avatar-color.directive';
@Component({
  selector: 'ldm-notification-container',
  imports: [
    AvatarColorDirective,
    ButtonModule,
    ProgressBarModule,
    TranslateModule,
    AvatarModule,
  ],
  templateUrl: './notification-container.component.html',
  styleUrls: ['./notification-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationContainerComponent implements AfterViewInit {
  public animation: ProgressBarAnimation = {
    duration: 5000,
  };
  @Output() public ignore: EventEmitter<undefined> = new EventEmitter();

  protected progressBarValue = 100;

  public message: string | undefined;

  // Notification style; mapped to an avatar color in initializeNotification().
  public type: string = 'info';
  public bgColor = 'bg-blue-500';
  public settings: NotificationSettings | undefined;
  public title: string | undefined;
  public icon!: string;
  public color!: string;
  public borderColor!: string;
  public themeColor!: AvatarColor;

  constructor(private cd: ChangeDetectorRef) {}
  ngAfterViewInit(): void {
    this.progressBarValue = 0;
  }

  public ignoreNotification(event: Event | AnimationEndEvent): void {
    if (event instanceof Event) {
      event.preventDefault();
    }
    this.ignore.emit();
  }

  public setUpNotification(
    notificationSettings: NotificationSettings,
    message: string,
  ): void {
    this.settings = notificationSettings;
    this.animation.duration = notificationSettings.hideAfter?.valueOf() ?? 5000;
    this.type = notificationSettings.type?.style ?? 'info';
    this.message = message;

    this.initializeNotification();
  }
  initializeNotification() {
    switch (this.type) {
      case 'success':
        this.title = 'notifications.success.title';
        this.icon = 'fa-circle-check';
        this.color = 'text-green-600';
        this.bgColor = 'bg-green-600';
        this.borderColor = 'border-green-600';
        this.themeColor = 'success';
        break;
      case 'error':
        this.title = 'notifications.error.title';
        this.icon = 'fa-exclamation-circle';
        this.color = 'text-red-500';
        this.bgColor = 'bg-red-500';
        this.borderColor = 'border-red-500';
        this.themeColor = 'error';
        break;
      case 'warning':
        this.title = 'notifications.warning.title';
        this.icon = 'fa-triangle-exclamation';
        this.color = 'text-yellow-400';
        this.bgColor = 'bg-yellow-400';
        this.borderColor = 'border-yellow-400';
        this.themeColor = 'warning';
        break;
      case 'info':
        this.icon = 'fa-circle-info';
        this.title = 'notifications.info.title';
        this.color = 'text-blue-500';
        this.bgColor = 'bg-blue-500';
        this.borderColor = 'border-blue-500';
        this.themeColor = 'info';
        break;
      default:
        this.icon = 'fa-circle-info';
        this.color = 'text-blue-500';
        this.bgColor = 'bg-blue-500';
        this.title = 'notifications.info.title';

        this.borderColor = 'border-blue-500';
        this.themeColor = 'info';
        break;
    }
    this.cd.detectChanges();
  }
}
